import { connect } from "react-redux";
import { get, isNull } from "lodash";
import { CompanyAnticipatedTransactionComponent } from "./CompanyAnticipatedTransactions";
import { getOrgKYCDetails } from "../../../../store/selectors/appConfig";

const mapStateToProps = state => ({
  dnfbpField:
    !isNull(
      get(getOrgKYCDetails(state), "anticipatedTransactionsDetails.isCompanyDesignated", "")
    ) &&
    get(getOrgKYCDetails(state), "anticipatedTransactionsDetails.isCompanyDesignated", "") !== ""
});

export const CompanyAnticipatedTransactions = connect(mapStateToProps)(
  CompanyAnticipatedTransactionComponent
);
